export const CLIPBOARD_TYPES = [
  { value: 'prompt', label: 'Prompt' },
  { value: 'asin', label: 'ASIN' },
  { value: 'gtin', label: 'GTIN' },
  { value: 'note', label: 'Note' },
];

export const CLIPBOARD_DEFAULT_TYPE = 'prompt';

export const CLIPBOARD_SAVED_PROMPT_TITLE = 'Saved prompt';

export const CLIPBOARD_INLINE_EDITABLE_TYPES = new Set(['prompt', 'note', 'gtin']);

const CLIPBOARD_TYPE_VALUES = new Set(CLIPBOARD_TYPES.map((t) => t.value));

export function normalizeClipboardType(type) {
  return CLIPBOARD_TYPE_VALUES.has(type) ? type : CLIPBOARD_DEFAULT_TYPE;
}

export const CLIPBOARD_FILTER_ALL = 'all';

export const CLIPBOARD_SORT_NEWEST = 'newest';
export const CLIPBOARD_SORT_OLDEST = 'oldest';

export const CLIPBOARD_ALL_META = {
  subtitle: 'Save prompts, ASINs, GTINs, and notes for quick reuse.',
  emptyTitle: 'Nothing saved yet',
  emptyHint: 'Save prompts and product IDs you reuse often.',
  addLabel: null,
};

export const CLIPBOARD_TYPE_META = {
  prompt: {
    label: 'Prompt',
    plural: 'Prompts',
    iconClass: 'bi-stars',
    subtitle: 'Reusable AI prompts — drop into chat with one click.',
    emptyTitle: 'No Prompts saved',
    emptyHint: 'Reusable AI prompts — drop into chat with one click.',
    addLabel: 'Add Prompt',
  },
  asin: {
    label: 'ASIN',
    plural: 'ASINs',
    iconClass: 'bi-upc-scan',
    subtitle: '10-char Amazon product IDs. Validated and linkable.',
    emptyTitle: 'No ASINs saved',
    emptyHint: '10-char Amazon product IDs. Validated and linkable.',
    addLabel: 'Add ASIN',
  },
  gtin: {
    label: 'GTIN',
    plural: 'GTINs',
    iconClass: 'bi-upc',
    subtitle: '8/12/13/14-digit barcodes with check-digit validation.',
    emptyTitle: 'No GTINs saved',
    emptyHint: '8/12/13/14-digit barcodes with check-digit validation.',
    addLabel: 'Add GTIN',
  },
  note: {
    label: 'Note',
    plural: 'Notes',
    iconClass: 'bi-journal-text',
    subtitle: 'Short notes — briefs, links, anything you want handy.',
    emptyTitle: 'No Notes saved',
    emptyHint: 'Short notes — briefs, links, anything you want handy.',
    addLabel: 'Add Note',
  },
};

/** Composer field layout per type (matches Lovable add forms). */
export const CLIPBOARD_COMPOSER_CONFIG = {
  prompt: {
    labelPlaceholder: 'Label (optional)',
    contentPlaceholder: 'Paste or type a prompt to save…',
    multiline: true,
    mono: false,
    bulkPaste: false,
  },
  asin: {
    labelPlaceholder: 'Label (optional)',
    contentPlaceholder: 'B0XXXXXXXX',
    bulkPlaceholder: 'One ASIN per line…',
    multiline: false,
    mono: true,
    bulkPaste: true,
  },
  gtin: {
    labelPlaceholder: 'Label (optional)',
    contentPlaceholder: '0000000000000',
    bulkPlaceholder: 'One GTIN per line…',
    multiline: false,
    mono: true,
    bulkPaste: true,
  },
  note: {
    labelPlaceholder: 'Title (optional)',
    contentPlaceholder: 'Note body…',
    multiline: true,
    mono: false,
    bulkPaste: false,
  },
};
